import { UrlConstants } from "../url.constants";
export class ApiAdvertisingConstants {
    static URL = UrlConstants.API_V2 + "Advertising";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetAdvertisingApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetAdvertisingProperties";
    static FUNCTION_RESET_APPLICATION_VALUES = "resetApplicationValues";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateAdvertisingInvoiceReport";
    static FUNCTION_GET_MY_AFLA_ADVERTISING_APPLICATIONS = "GetMyAFLAPortalAdvertisingApplications";
    static FUNCTION_GET_APPLICATION_TYPE = "GetAApplicationTypes";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalAdvertisingApplication";
    static FUNCTION_GET_ALL_AFLA_PORTAL_ADVERTISING_APPLICATIONS = "GetAllAFLAPortalAdvertisingApplications";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalAdvertisingApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetAdvertisingRequiredDocumentsChecklist";
}
